/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type {QualityModelArguments} from './quality-model-arguments';

/**
 *
 * @export
 * @interface WriteQualityModelAttribute
 */
export interface WriteQualityModelAttribute {
  /**
   *
   * @type {boolean}
   * @memberof WriteQualityModelAttribute
   */
  isPinned: boolean;
  /**
   *
   * @type {string}
   * @memberof WriteQualityModelAttribute
   */
  assignmentType?: WriteQualityModelAttributeAssignmentTypeEnum;
  /**
   *
   * @type {QualityModelArguments}
   * @memberof WriteQualityModelAttribute
   */
  customArguments?: QualityModelArguments;
}

export const WriteQualityModelAttributeAssignmentTypeEnum = {
  Default: 'default',
  Automatic: 'automatic',
  Custom: 'custom',
} as const;

export type WriteQualityModelAttributeAssignmentTypeEnum =
  (typeof WriteQualityModelAttributeAssignmentTypeEnum)[keyof typeof WriteQualityModelAttributeAssignmentTypeEnum];
